import { Box, Typography } from "@mui/material";
import { AxiosResponse } from "axios";
import React, { memo } from "react";
import ProgressIndicator from "../../../common/progressIndicator/ProgressIndicator";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ResultPage from './Result';
interface ShowResultProps {
  isLoading: boolean;
  updateResult?: any;
}

const classes = {
  iconSuccess: {
    color: "#0FBF00",
    marginBottom: 5,
  },
  iconFailed: {
    color: "#DB1313",
    marginBottom: 10,
  },
};

// helpper functions
const isSuccessResponse = (response: AxiosResponse) => {
  return response.hasOwnProperty("data") && !response.data.error;
};

const ShowResult = (props: ShowResultProps) => {
  const { isLoading, updateResult } = props;

  // result components
  const SuccessIcon = (
    <CheckCircleOutlineIcon fontSize="large" sx={classes.iconSuccess} />
  );

  const FailIcon = (
    <HighlightOffIcon fontSize="large" sx={classes.iconFailed} />
  );

  const FailMsg = (
    <Box width="100%" textAlign="center">
      {FailIcon}
      <Typography>
        Saving failed! <br />
        Something went wrong with updating data. Please go back and try again.
      </Typography>
    </Box>
  );

  // handle show result
  const showResult = (updateResult: ShowResultProps["updateResult"]) => {
    if (updateResult && isSuccessResponse(updateResult)) {
      const { attributes } = updateResult?.data;
      return (
        <ResultPage data={updateResult?.data} />
      );
    } else {
      if (updateResult?.data.error) {
        return (
          <Box width="100%" textAlign="center">
            {FailIcon}
            <Typography>
              Importing failed!
              <br/>
              {updateResult?.data.error}
            </Typography>
          </Box>
        );
      } else {
        return <>{FailMsg}</>;
      }
    }
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      width="100%"
      padding={4}
    >
      {isLoading ? (
        <Box width="100%" textAlign="center">
          <ProgressIndicator />
          <Typography>
            Updating data...
            <br />
            Please wait a moment
          </Typography>
        </Box>
      ) : (
        <Box width="100%" textAlign="center">
          {showResult(updateResult)}
        </Box>
      )}
    </Box>
  );
};

export default memo(ShowResult);
